export default {
  HEALTH_PLAN_LIST: {
    TITLE: {
      title: 'Select Your Health Plan'
    }
  },
  INSURANCE_TEXT: {
    INSURANCE_STATUS_IS_PRIMARY: 'Select the option that best describes your insurance status:',
    INSURANCE_STATUS: "Select the option that best describes this individual's insurance status:",
    HAS_INSURANCE_IS_PRIMARY: 'I have insurance',
    HAS_INSURANCE: 'This individual has insurance',
    NO_INSURANCE_IS_PRIMARY: 'I do not have insurance',
    NO_INSURANCE: 'This individual does not have insurance',
    NOT_LISTED_OR_SKIP_IS_PRIMARY: "My plan isn't listed / Skip this step",
    NOT_LISTED_OR_SKIP: "This individual's plan is not listed / Skip this step"
  },
  INSURANCE_OPTIONS: {
    INSURED: 'insured',
    UNINSURED: 'uninsured',
    SKIP: 'skip'
  },
  IS_PRIMARY_SUBSCRIBER_OPTIONS: [
    {
      label: 'Yes',
      value: 'Yes'
    },
    {
      label: 'No',
      value: 'No'
    }
  ],
  SHOULD_USE_PRIMARY_SUBSCRIBER_INFO_OPTIONS: [
    {
      label: 'Yes',
      value: 'Yes'
    },
    {
      label: 'No',
      value: 'No'
    }
  ],
  SELF: 'Self'
};
